/** @format */
import { api } from 'utility';
import axios from 'axios';

import { getStatesUrl, getCitiesUrl , neshanSearchUrl } from 'URLs';
export function getStates() {
  return api.get(getStatesUrl()).then((res) => res.data);
}
export function getCities(params) {
  return api.get(getCitiesUrl(), { params }).then((res) => res.data);
}
export function neshanSearch(obj) {
  const url = neshanSearchUrl(obj);
  var params = {
    headers: {
      'Api-Key': `${process.env.REACT_APP_NESHAN_API_KEY}`,
    },
  };

  return axios.get(url, params);
}
export default {
  getStates,
  getCities,
  neshanSearch,
};
